// extracted by mini-css-extract-plugin
export default {"button":"style_button__v4JZI","icon":"style_icon__3KalN","active":"style_active__Znh7i","label":"style_label__AO81a"};